module.exports = __webpack_public_path__ + "static/media/stat547u_lecture01.4aee32b9.pdf";